export default __webpack_public_path__ + "8e4a77699110907084b9bf9da185553d.svg";